import { StackScreenProps } from "@react-navigation/stack";
import { SetupRootParamList } from "../../../../types";
import { SetupLocation } from "../../components/SetupLocation";
import { useActiveLocation } from "../../../../utilities/app-state/hooks";
import { useEffect } from "react";
import { Button } from "@towersystems/roam-common-native";

export type SetupSelectLocationScreenProps = StackScreenProps<
  SetupRootParamList,
  "SetupSelectLocationScreen"
>;

export const SetupSelectLocationScreen = ({
  navigation,
}: SetupSelectLocationScreenProps) => {
  const { location } = useActiveLocation();

  useEffect(() => {
    navigation.setOptions({
      headerRight: () => (
        <Button
          label="Continue"
          isAction
          onPress={() => navigation.navigate("SetupSelectTerminalScreen")}
          size="compact"
          disabled={!location?.id}
        ></Button>
      ),
    });
  }, [location?.id]);

  return (
    <SetupLocation
      afterSubmit={() => navigation.navigate("SetupSelectTerminalScreen")}
    />
  );
};
